export default {
  html: {
    title: 'Login'
  },
  title: 'Bem vindo ao',
  subtitle: 'VLALG'
}
